<template>
  <b-row>
    <b-column size="6/12">
      <date-picker
        :key="filterElement.id + '-1'"
        :mode="mode"
        v-model="minDatetime"
        :max="maxDatetime"
        :allow-input="true"
      ></date-picker>
    </b-column>
    <b-column>
      <date-picker
        :key="filterElement.id + '-2'"
        :mode="mode"
        v-model="maxDatetime"
        :min="minDatetime"
        :allow-input="true"
      ></date-picker>
    </b-column>
  </b-row>
</template>

<script lang="ts">
  import Vue from "vue";
  import DatePicker from "../../../common/components/datePicker.vue";
  import {DatetimeMode} from "../../../common/models/datetimeMode";
  import {DefaultDates} from "../../../common/enums/listViews/defaultDates";
  import listViewFilterMixin from '../../../common/mixins/listViews/listViewFilterMixin';
  import moment from 'moment-timezone';
  import organizationMixin from "~/mixins/organizationMixin";

  export default Vue.extend({
    components: {
      DatePicker,
    },
    mixins: [
      listViewFilterMixin,
      organizationMixin
    ],
    data: function () {
      return {
        minDatetime: '',
        maxDatetime: '',
      };
    },
    computed: {
      mode(): DatetimeMode {
        if (this.filterElement.propertyToFilter.linked_relation_mapped_properties &&
            this.filterElement.propertyToFilter.linked_relation_mapped_properties.length > 0) {
          return 2
        }
        return this.filterElement.propertyToFilter.datetime_mode;
      },
      minQueryValue(): string {
        if (this.queryValue && this.queryValue.split(' ')[0] ) {
          return this.queryValue.split(' ')[0].replace('start=', '')
        } else {
          return null
        }
      },
      maxQueryValue(): string {
        if (this.queryValue && this.queryValue.split(' ')[1]) {
          return this.queryValue.split(' ')[1].replace('end=', '')
        } else {
          return null
        }
      },
    },
    methods: {
      setDefaultFilter(): void {
        if (this.isFilterInQuery || this.isInDashBoardDrillDown) {
          this.minDatetime = this.minQueryValue
          this.maxDatetime = this.maxQueryValue
        } else {

          const startOfToday = moment().utc().startOf('day').toISOString().replace("Z", "+00:00")
          const endOfToday = moment().utc().endOf('day').toISOString().replace("Z", "+00:00")

          switch (this.filterElement.default_property_filter_option_id as DefaultDates) {
            case DefaultDates.None:
              break;
            case DefaultDates.PickDates:
              this.minDatetime = this.filterElement.start_datetime;
              this.maxDatetime = this.filterElement.end_datetime;
              break;
            case DefaultDates.CurrentDate:
              this.minDatetime = startOfToday
              this.maxDatetime = endOfToday
              break;
            case DefaultDates.BeforeCurrentDate:
              this.maxDatetime = endOfToday
              break;
            case DefaultDates.AfterCurrentDate:
              this.minDatetime = startOfToday
              break;
            default:
              break;
          }
        }
      },
      updateFilter(): void {
        let query = '';
        if (this.minDatetime) {
          query += `start=${this.minDatetime}`;
        }
        if (this.maxDatetime) {
          if (this.minDatetime) query += ' ';
          query += `end=${this.maxDatetime}`;
        }
        this.addFilterToQuery(query);
      },
      reset(): void {
        this.minDatetime = null;
        this.maxDatetime = null;
      },
    },
    watch: {
      minDatetime: 'updateFilter',
      maxDatetime: 'updateFilter',
    },
  });
</script>